var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(!_vm.initialLoad)?_c('div',{staticClass:"app-load-container"},[_c('div',{staticClass:"app-load-box"},[_c('h2',[_vm._v("Loading Dashboard...")]),_vm._v(" "),_c('Spinner',{staticClass:"app-load"})],1)]):_c('div',{},[(_vm.notify && _vm.notify.msg)?_c('div',{class:{"top-alert": true, error: _vm.notify.error, "slide-away": _vm.notify.slideAway}},[_c('h1',[_vm._v(_vm._s(_vm.notify.msg))])]):_vm._e(),_vm._v(" "),_c('router-view')],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3afa4a4b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 478
// module chunks = 1